import { Component, OnInit, Input, Inject } from "@angular/core";
import { EvaluationService } from "@app-services/evaluation.service";
import { BuyPriceDetails, PriceRange } from "@app-model/pricing";
import { EvaluationVehicle } from "@app-model/evaluation";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-price-gradient-bar",
  templateUrl: "./price-gradient-bar.component.html",
  styleUrls: ["./price-gradient-bar.component.scss"],
})
export class PriceGradientBarComponent implements OnInit {
  @Input()
  prices?: PriceRange;

  constructor() {}
  ngOnInit() {}
}
